function initializeControls() {
    document.addEventListener('click', (event) => {
        const control = event.target instanceof Element ? event.target.closest('[data-logout]') : null;

        if (!control) {
            return;
        }

        event.preventDefault();
        document.querySelector<HTMLFormElement>('#logoutForm')?.requestSubmit();
    });
    document.addEventListener('keydown', (event) => {
        const button =
            event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[role="button"]') : null;

        if (button && (event.key === ' ' || (event.key === 'Enter' && !button.hasAttribute('href')))) {
            event.preventDefault();
            button.click();
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeControls, { once: true });
} else {
    initializeControls();
}
